module.exports = __webpack_public_path__ + "img/mastercard.a05125bc.svg";